import { GiveawaySheetModal, type GiveawaySheetModalReturnRef } from './Giveaway';
import {
    OrderGiveawaySheetModal,
    type OrderGiveawaySheetModalReturnRef,
} from './OrderGiveaway';
import { CouponSheetModal, type CouponSheetModalReturnRef } from './Coupon';
import { RecommendSheetModal, type RecommendSheetModalReturnRef } from './Recommend';

export const SheetModal = {
    Giveaway: GiveawaySheetModal,
    OrderGiveaway: OrderGiveawaySheetModal,
    Coupon: CouponSheetModal,
    Recommend: RecommendSheetModal,
};

export {
    type GiveawaySheetModalReturnRef,
    type OrderGiveawaySheetModalReturnRef,
    type CouponSheetModalReturnRef,
    type RecommendSheetModalReturnRef,
};
